import axios from "axios";
import Config from "../../config";

const actionListaDiagnosticosPorChat = (chatId) =>
    axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat/${chatId}/diagnosticos`,
    });

export default actionListaDiagnosticosPorChat;
